import { defaultImage, getSanitizedPrice, getSanitizedQuantity, prepareDataFormatingInitOptionalAttribute, prepareDataFormatingOptionalAttribute, restructureAttributeSchemaToCompare } from "../utils/utils";
import { ACTION_TYPE } from "./actiontypes";
import { compareObjects } from '../utils/utils'

export function reducer(state: any, action: any) {
    switch (action.type) {
        case "title":
            return {
                ...state,
                ...removeError(state, action, 'title'),
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.payload, 'title')
                },
                data: {
                    ...state['data'],
                    ...action.payload,
                },
            };
        case "description":
            return {
                ...state,
                ...removeError(state, action, 'description'),
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.payload, 'description')
                },
                data: {
                    ...state['data'],
                    ...action.payload,
                },
            };
        case ACTION_TYPE.INVENTORY_FULFILLMENT_LATENCY:
            return {
                ...state,
                ...removeError(state, action, ACTION_TYPE.INVENTORY_FULFILLMENT_LATENCY),
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.payload, 'inventory_fulfillment_latency')
                },
                data: {
                    ...state['data'],
                    ...action.payload,
                },
            };
        case "sku":
            return {
                ...state,
                ...removeError(state, action, 'sku'),
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.payload, 'sku')
                },
                data: {
                    ...state['data'],
                    ...action.payload,
                },
            };
        case "barcode_exemption":
            let tempPayload = { ...action.payload }
            if (action.payload.barcode_exemption && state?.['selection_type']?.['barcode'] === "custom" && (!state?.['data']?.['barcode'])) {
                tempPayload['barcode'] = state?.['shopify_data']?.['barcode'];
                tempPayload['barcode_type'] = state?.['shopify_data']?.['barcode_type'];
            }
            return {
                ...state,
                ...removeError(state, action, 'barcode'),
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.payload, 'barcode_exemption')
                },
                data: {
                    ...state['data'],
                    ...tempPayload,
                },
            };
        case ACTION_TYPE.ONLINE_SELLING:
            return {
                ...state,
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.payload, 'onlineSelling')
                },
                data: {
                    ...state['data'],
                    ...action.payload
                }
            };
        case ACTION_TYPE.LOCAL_SELLING:
            return {
                ...state,
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.payload, 'localSelling')
                },
                data: {
                    ...state['data'],
                    ...action.payload
                }
            };
        case ACTION_TYPE.LOCAL_SELLING_STORE_DATA:
            return {
                ...state,
                ...removeError(state, action.payload, 'localsellingStoreData'),
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.payload, 'local_selling_store_data')
                },
                ...action.payload
            };
        case ACTION_TYPE.PRICE:
            return {
                ...state,
                ...removeError(state, action, ACTION_TYPE.PRICE),
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.payload, 'price')
                },
                data: {
                    ...state['data'],
                    price: action.payload,
                },
            };
        case ACTION_TYPE.BUSINESS_PRICE:
            return {
                ...state,
                ...removeError(state, action, ACTION_TYPE.BUSINESS_PRICE),
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.payload, 'business_price')
                },
                data: {
                    ...state['data'],
                    ...action.payload,
                },
            };
        case ACTION_TYPE.BUSINESS_PRICE_ENABLED:
            return {
                ...state,
                ...removeError(state, action, ACTION_TYPE.BUSINESS_PRICE_ENABLED),
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.payload, ACTION_TYPE.BUSINESS_PRICE_ENABLED)
                },
                data: {
                    ...state['data'],
                    ...action.payload,
                },
            };
        case ACTION_TYPE.QUANTITY:
            console.log(state, action, "vfjbcj");

            return {
                ...state,
                ...removeError(state, action, ACTION_TYPE.QUANTITY),
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.payload, 'quantity')  
                },
                data: {
                    ...state['data'],
                    quantity: { ...action.payload },
                },
            };
        // case ACTION_TYPE.QUANTITY:
        //     return {
        //         ...state,
        //         ...removeError(state, action, ACTION_TYPE.QUANTITY),
        //         mutated: {
        //             ...state['mutated'],
        //             ...isMutated(state, action.payload, 'quantity')
        //         },
        //         data: {
        //             ...state['data'],
        //             ...action.payload,
        //         },
        //     };
        case ACTION_TYPE.FULFILLMENT_TYPE:
            return {
                ...state,
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.payload, 'fulfillment_type')
                },
                data: {
                    ...state['data'],
                    ...action.payload,
                },
            };
        case ACTION_TYPE.BARCODE:
            return {
                ...state,
                ...removeError(state, action, ACTION_TYPE.BARCODE),
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.payload, 'barcode')
                },
                data: {
                    ...state['data'],
                    ...action.payload,
                },
            };
        case ACTION_TYPE.BARCODE_TYPE_TEMP:
            return {
                ...state,
                data: {
                    ...state['data'],
                    ...action.payload,
                },
            };


        case ACTION_TYPE.BARCODE_TYPE:
            return {
                ...state,
                ...removeError(state, action, ACTION_TYPE.BARCODE_TYPE),
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.payload, 'barcode_type')
                },
                data: {
                    ...state['data'],
                    ...action.payload,
                },
            };
        case ACTION_TYPE.INITIAL_COMPONENT_STATE:
            return {
                ...state,
                mutated: {
                    ...state['mutated'],
                    ...isMutated(action.payload, state, 'initial_attributes_comparison'),
                },
                initialComponentState: {
                    ...state['initialComponentState'],
                    ...action.payload,
                    // category_settings: {
                    //     ...state['initialComponentState']?.category_settings,
                    //     attributes_mapping: {
                    //         ...state['initialComponentState']?.category_settings?.attributes_mapping,
                    //         ...action.payload,
                    //     }
                    // }
                },
            };
        case ACTION_TYPE.DELETE_IMAGE:
            let { delete_image } = action.payload;
            let index = state['selected_images'].indexOf(delete_image);
            let temp: any = [...state['selected_images']];
            temp.splice(index, 1);
            for (let i = 0; i < (9 - temp.length); i++) {
                temp.push(defaultImage);
            }
            return {
                ...state,
                data: {
                    ...state['data'],
                    main_image: temp[0],
                    additional_images: [...temp].filter(
                        (ele, index) => ele != defaultImage
                    ),
                },
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, temp, 'delete_image'),
                },
                selected_images: [...temp],
            };
        case ACTION_TYPE.REPLACE_IMAGE: {
            let { newIndex, oldIndex } = action.payload;
            let tempReplaceImageHolder: any = [...state.selected_images];
            if (newIndex != oldIndex) {
                arraymove(tempReplaceImageHolder, oldIndex, newIndex);
            }
            return {
                ...state,
                selected_images: [...tempReplaceImageHolder],
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.payload, 'replace_image'),
                },
                data: {
                    ...state['data'],
                    main_image: tempReplaceImageHolder[0],
                },
            };
        }
        case ACTION_TYPE.SELECTED_IMAGES:
            let tempImageHolder = [
                ...addImage(state['selected_images'], action.payload.selected_images)
            ]
            let flattendArray = [].concat.apply([], tempImageHolder);
            return {
                ...state,
                ...removeError(state, action, 'image_selection'),
                data: {
                    ...state['data'],
                    main_image: flattendArray[0],
                    additional_images: [
                        ...flattendArray.filter(
                            (ele, index) => ele != defaultImage
                        ),
                    ],
                },
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, tempImageHolder, 'selected_images'),
                },
                selected_images: [...tempImageHolder],
            };
        case "additional_image":
            return {
                ...state,
                data: {
                    ...state['data'],
                    ...action.payload,
                },
            };
        case ACTION_TYPE.ADD_NEW_SHOPIFY_IMAGES:
            return {
                ...state,
                ...action.payload
            }
        case 'updateAll':
            return {
                ...state,
                ...action.payload
            }
        case 'selection_type':
            return {
                ...state,
                ...removeError(state, action.payload, Object.keys(action?.payload)[0]),
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.payload, 'selection_type')
                },
                selection_type: { ...state['selection_type'], ...action.payload },
            }
        case ACTION_TYPE.LIST_AS:
            return {
                ...state,
                ...action.payload
            }
        case ACTION_TYPE.MODAL_ACTION:
            return {
                ...state,
                modal: {
                    ...action.payload
                }
            }
        case ACTION_TYPE.UPLOAD_IMAGE_ARRAY:
            return {
                ...state,
                ...action.payload
            }
        case ACTION_TYPE.ERRORS:
            return {
                ...state,
                ...action.payload
            }
        case ACTION_TYPE.VARIANTS:
            return {
                ...state,
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.field_payload, action?.['field_payload']?.['identifier'], action)
                },
                ...action.payload
            }
        case ACTION_TYPE.SELECTED_CATEGORY: {
            return {
                ...state,
                ...action.payload
            }
        }
        case ACTION_TYPE.ALL_CATEGORIES:
            return {
                ...state,
                ...action.payload
            }
        case ACTION_TYPE.ATTRIBUTES_CHANGED:
            return {
                ...state,
                ...action.payload
            }
        case ACTION_TYPE.PRODUCT_ATTRIBUTES:
            return {
                ...state,
                ...action.payload
            }
        case ACTION_TYPE.SET_PRIMARY_SECONDARY_CATEGORIES:
            return {
                ...state,
                category_settings: {
                    ...state['category_settings'],
                    ...action.payload
                },
            }
        case ACTION_TYPE.SET_required_attribute:
            return {
                ...state,
                ...removeError(state, [], 'flush_attributes_error'),
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.payload, 'flush_attributes')
                },
                category_settings: {
                    ...state?.['category_settings'],
                    attributes_mapping: {
                        ...state?.['category_settings']?.['attributes_mapping'],
                        ...action.payload

                    }
                },
            }
        case ACTION_TYPE.SET_RAW_ATTRIBUTES:
            return {
                ...state,
                raw_attribute: {
                    ...state?.['raw_attribute'],
                    ...action.payload,
                },
            }

        case ACTION_TYPE.ADD_NEW_OPTIONAL_ATTRIBUTE:
            return {
                ...state,
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.payload, 'update_optional_attributes')
                },
                category_settings: {
                    ...state['category_settings'],
                    attributes_mapping: {
                        ...state['category_settings']['attributes_mapping'],
                        ...action.payload

                    }
                },
            }
        case ACTION_TYPE.SET_OPTIONAL_AMAZON_OPTIONS:
            return {
                ...state,
                ...action.payload
            }
        case ACTION_TYPE.UPDATE_SHOPIFY_ATTRIBUTE:
            return {
                ...state,
                ...removeError(state, action.field_payload, 'required_attributes'),
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.field_payload, 'attributes')
                },
                category_settings: {
                    ...state['category_settings'],
                    attributes_mapping: {
                        ...state['category_settings']['attributes_mapping'],
                        ...action.payload
                    }
                },
            }
        case ACTION_TYPE.UPDATE_AMAZON_ATTRIBUTE:
            return {
                ...state,
                ...removeError(state, action.field_payload, 'optional_attribute'),
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.field_payload, 'optional_attribute', action)
                },
                category_settings: {
                    ...state['category_settings'],
                    attributes_mapping: {
                        ...state['category_settings']['attributes_mapping'],
                        ...action.payload
                    }
                },
            }
        case ACTION_TYPE.UPDATE_OPTIONAL_ATTRIBUTE:
            return {
                ...state,
                category_settings: {
                    ...state['category_settings'],
                    mutated: {
                        ...state['mutated'],
                        ...isMutated(state, action.field_payload, 'optional_attribute', action)
                    },
                    attributes_mapping: {
                        ...state['category_settings']['attributes_mapping'],
                        ...action.payload
                    }
                },
            }
        case ACTION_TYPE.SET_VARIATION_THEME:
            return {
                ...state,
                ...action.payload
            }
        case ACTION_TYPE.UPDATE_VARIATION_THEME:
            return {
                ...state,
                ...removeError(state, action.field_payload, 'variation_theme'),
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.payload, 'variation_theme'),
                },
                ...action.payload
            }
        case ACTION_TYPE.UPDATE_VARIATION_THEME_ATTRIBUTES:
            return {
                ...state,
                ...removeError(state, action.payload, 'variation_theme_attributes'),
                mutated: {
                    ...state['mutated'],
                    ...isMutated(state, action.payload, 'variation_theme_attributes'),
                },
                ...action.payload
            }
        case ACTION_TYPE.LISTING_TYPE:
            return {
                ...state,
                ...action.payload
            }
        case ACTION_TYPE.FORMATTED_DATA:
            return {
                ...state,
                ...action.payload
            }
        case ACTION_TYPE.SET_DISPLAY_PATH:
            return {
                ...state,
                ...action.payload,
                ...isMutated(state, action.payload, 'displayPath', action)
            }
        case ACTION_TYPE.LISTING_TYPE_CHANGED:
            return {
                ...state,
                ...action.payload
            }
        case ACTION_TYPE.REFRESH_ATTRIBUTES:
            return {
                ...state,
                ...action.payload
            }
        case ACTION_TYPE.EDITED_VARIANT_ATTRIBUTES:
            return {
                ...state,
                ...removeError(state, action.field_payload, 'edited_variants_attributes'),
                ...action.payload,
                ...isMutated(state, action.field_payload, 'edited_variants_attributes', action)
            }
        case ACTION_TYPE.PRODUCTS_VALUE_ON_SHOPIFY:
            return {
                ...state,
                ...action.payload
            }
        default:
            break;
    }
}

function removeError(state: any = [], payload: any = [], field: any = '') {
    let tempError: any = [...state?.['errors'] ?? []];
    if (state?.['errors']) {
        if (field === 'barcode' && state?.data?.barcode_exemption) {
            if (tempError?.[0]?.['barcode']) {
                tempError.forEach((elem: any) => {
                    elem['barcode'] = false
                });
            }
        }
        else if (field === 'barcode_type' && state?.data?.barcode_exemption) {


            if (tempError?.[0]?.['barcode_type']) {
                tempError.forEach((elem: any) => {
                    elem['barcode_type'] = false
                });
            }
        }
        else if (field === 'required_attributes') {
            if (tempError.length > 1) {
                tempError = tempError.filter((elem: any) => elem?.['parent']);
                if (tempError[0]?.category_settings?.attributes_mapping?.required_attribute?.[payload['index']]?.[payload['field']]) {
                    tempError[0].category_settings.attributes_mapping.required_attribute[payload['index']][payload['field']] = false;
                }
            }
            else
                if (tempError[0]?.category_settings?.attributes_mapping?.required_attribute?.[payload['index']]?.[payload['field']]) {
                    tempError[0].category_settings.attributes_mapping.required_attribute[payload['index']][payload['field']] = false;
                }
        }
        else if (field === 'edited_variants_attributes') {
            if (tempError?.length > 0) {
                if (tempError?.[0]?.['edited_variant_attributes']?.[payload['index']]?.[payload['field']]) {
                    tempError[0]['edited_variant_attributes'][payload['index']][payload['field']] = false;
                }
            }
        }
        else if (field === 'optional_attribute') {
            if (tempError.length > 1) {
                tempError = tempError.filter((elem: any) => elem?.['parent']);
                if (tempError[0]?.category_settings?.attributes_mapping?.optional_attribute?.[payload['index']]?.[payload['field']]) {
                    tempError[0].category_settings.attributes_mapping.optional_attribute[payload['index']][payload['field']] = false;
                }
            }
            else {
                if (tempError[0]?.category_settings?.attributes_mapping?.optional_attribute?.[payload['index']]?.[payload['field']]) {
                    tempError[0].category_settings.attributes_mapping.optional_attribute[payload['index']][payload['field']] = false;
                }
            }
        }
        else if (field === 'variation_theme') {
            if (tempError.length > 1) {
                tempError = tempError.filter((elem: any) => elem?.['parent']);
                if (tempError[0]?.['variation_theme_attribute_name']) {
                    tempError[0]['variation_theme_attribute_name'] = false;
                }
            }
            else {
                if (tempError[0]?.['variation_theme_attribute_name']) {
                    tempError[0]['variation_theme_attribute_name'] = false;
                }
            }
        }
        else if (field === 'image_selection') {
            if (tempError?.[0]?.['image_selection']) {
                tempError.forEach((elem: any) => {
                    elem['image_selection'] = false
                });
            }
        }
        else if (field === 'localsellingStoreData') {
            if (Object.keys(tempError?.[0]?.['localsellingStoreData'])?.length > 0) {
                if (payload?.value === 'textField' && payload?.['localsellingStoreData']?.[payload?.index]?.store_enabled && payload?.['localsellingStoreData']?.[payload?.index]?.store_value.trim().length > 0) {
                    tempError[0]['localsellingStoreData'][payload?.['localsellingStoreData']?.[payload?.index]?.['store_id']] = false
                } else if (payload?.value === 'multiSelect' && payload?.['localsellingStoreData']?.[payload?.index]?.store_enabled && Object.values(payload?.['localsellingStoreData']?.[payload?.index]?.shopify_location ?? {})?.length > 0) {
                    tempError[0]['localsellingStoreData'][payload?.['localsellingStoreData']?.[payload?.index]?.['store_id']] = false
                } else {
                    if (tempError[0]['localsellingStoreData'][payload?.['localsellingStoreData']?.[payload?.index]?.['store_id']] && !payload?.['localsellingStoreData']?.[payload?.index]?.store_enabled) {
                        tempError[0]['localsellingStoreData'][payload?.['localsellingStoreData']?.[payload?.index]?.['store_id']] = false
                    }
                }
            }
        }
        else if (field === 'variation_theme_attributes') {
            tempError.forEach((elem: any) => {
                elem[field] = false;
            })
        }
        else if (field === 'flush_attributes_error') {
            let idx = tempError.findIndex((a: any) => a.parent)
            if (idx >= 0) {
                tempError[idx].category_settings = { attributes_mapping: { required_attribute: [], optional_attribute: [] } };
                tempError[idx].variation_theme_attribute_name = false;
            }
            tempError = tempError.filter((_: any, index: number) => index !== idx).map((err: any) => {
                err.variation_theme_fields = {}
            })
        }
        else {
            state.errors.forEach((elem: any) => {
                elem[field] = false;
            })
        }
        return { ...tempError }
    }
}

function addImage(previousImages: any = [], newImages: any = []) {
    let temp: any = [...previousImages];
    if (!previousImages.includes(newImages)) {
        let index = previousImages.indexOf(defaultImage);
        temp[index] = newImages;
    }
    return temp;
}

function arraymove(arr: any, fromIndex: number, toIndex: number) {
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
    return arr;
}

const compareImages = (prevArr: any, newArr: any) => {
    prevArr = prevArr.filter((x: any) => x !== "https://i.imgur.com/oUVyG2C.png");
    newArr = newArr.filter((x: any) => x !== "https://i.imgur.com/oUVyG2C.png");
    let change = false;
    if (prevArr.length !== newArr.length || prevArr[0] !== newArr[0]) {
        return true;
    } else {
        newArr.map((image: any) => {
            if (!prevArr.includes(image)) {
                change = true;
            }
        })
    }
    return change;
}

export function isMutated(previousState: any, newState: any, field: string | any, action?: any) {
    let { initialComponentState, selection_type } = previousState;
    if (field === 'onlineSelling') {
        previousState.onSaveBarChange(initialComponentState['data'][Object.keys(newState)[0]] != Object.values(newState)[0], field);
    } else if (field === 'localSelling') {
        previousState.onSaveBarChange(initialComponentState['data'][Object.keys(newState)[0]] != Object.values(newState)[0], field);
    } else if (field === 'local_selling_store_data') {
        previousState.onSaveBarChange(JSON.stringify(initialComponentState['localsellingStoreData']) != JSON.stringify(newState?.localsellingStoreData), field);
    }
    else if (field === 'inventory_fulfillment_latency') {
        previousState.onSaveBarChange(initialComponentState['data'][Object.keys(newState)[0]] != Object.values(newState)[0], 'inventory_fulfillment_latency');
    }
    else if (field === 'selected_images' || field === 'delete_image' || field === 'replace_image') {
        let oldImgState = initialComponentState?.selected_images;
        let newImgState = field === "replace_image" ? newState.selected_images : newState;
        previousState.onSaveBarChange(compareImages(oldImgState, newImgState), 'image_change');
    } else if (field === 'selection_type') {
        if (Object.keys(newState)[0] === 'description' && initialComponentState['selection_type'][Object.keys(newState)[0]] === Object.values(newState)[0]) {
            //this exceptional case is handle for description section when select default from custom descriptiondescription should be false
            previousState.onSaveBarChange(false, 'description' + Object.keys(newState)[0]);
        }
        previousState.onSaveBarChange(initialComponentState['selection_type'][Object.keys(newState)[0]] != Object.values(newState)[0], field + '_' + Object.keys(newState)[0]);
    }
    else if (field === 'displayPath') {
        if (newState['displayPath']?.edited?.length > 0) {
            previousState.onSaveBarChange(JSON.stringify(initialComponentState['displayPath']) !== JSON.stringify(newState['displayPath']), 'displayPath');
        } else {
            previousState.onSaveBarChange(false, 'displayPath');
        }
    }
    else if (field === 'description') {
        // if (newState.focus) {

        let oldValue = initialComponentState['data']['description']
        // .replace(/ /g, '&nbsp;');
        let newValue = newState['description']
        // .replace(/ /g, '&nbsp;');

        let oldString = oldValue
            .replace(/<(?!a\s*\/?)[^>]+>/g, '');

        let newString = newValue
            .replace(/<(?!a\s*\/?)[^>]+>/g, '');
        oldString = oldString.replace(/\n/, '');
        newString = newString.replace(/\n/, '');

        let CHECK = previousState.selection_type.description != 'custom' && oldString != newString;
        if (previousState.selection_type.description === 'custom') {
            // previousState.onSaveBarChange(oldString !== newString, field + 'description');
            previousState.onSaveBarChange(oldString.replace(/\n/g, '&nbsp;').replace(/&#39;/g, "'") !== newString.replace(/\n/g, '&nbsp;').replace(/&#39;/g, "'"), field + 'description');
        }
        else {
            previousState.onSaveBarChange(CHECK, field + 'description');
        }
        // }
    }
    else if (field === 'edited_variants_attributes') {
        let tempData: any = [];
        if (action?.['payload']?.['edited_variant_attributes']?.length > 0) {
            action?.['payload']?.['edited_variant_attributes'].map((elem: any, index: number) => {
                if (elem?.['custom_text']) {
                    elem['custom_text'] =
                        //  to overwrite changes in custom text
                        elem?.shopify_select?.value?.value === 'Search'
                            ? initialComponentState?.[
                            'edited_variant_attributes'
                            ]?.[index]?.['custom_text']
                            : elem?.['custom_text'];
                }

                if (elem?.['shopify_attribute']?.['value']) {
                    elem['shopify_attribute']['value'] =
                        //  to overwrite changes in shopify attribute
                        elem.shopify_select.value.value === 'custom'
                            ? {
                                label: initialComponentState?.[
                                    'edited_variant_attributes'
                                ]?.[index]?.['shopify_attribute'],
                                value: initialComponentState?.[
                                    'edited_variant_attributes'
                                ]?.[index]?.['shopify_attribute'],
                            }
                            : elem['shopify_attribute']['value'];
                }
                tempData.push({
                    amazon_attribute: elem?.amazon_attribute != '' ? elem?.amazon_attribute : elem?.['value'] ?? '',
                    custom_text: elem?.['custom_text'] ?? '',
                    recommendation: elem?.['recommendation']?.['value']?.['value'] ?? initialComponentState?.['edited_variant_attributes']?.[index]?.['recommendation'] ?? '',
                    shopify_attribute: elem?.['shopify_attribute']?.['value']?.['value'],
                    //  ?? initialComponentState?.['edited_variant_attributes']?.[index]?.['shopify_attribute'] ?? '',
                    shopify_select: elem?.['shopify_select']?.['value']?.['value'] ?? initialComponentState?.['edited_variant_attributes']?.[index]?.['shopify_select'] ?? '',
                })
            })
        }
        let tempInitialState = prepareDataFormatingOptionalAttribute(initialComponentState?.['edited_variant_attributes']);
        let tempCurrentState = prepareDataFormatingOptionalAttribute(tempData);
        previousState.onSaveBarChange(JSON.stringify(tempInitialState) != JSON.stringify(tempCurrentState), "edited_variant_attributes");
    }
    else if (field === 'initial_attributes_comparison') {
        let init_required_attribute = previousState?.category_settings?.attributes_mapping?.required_attribute;
        let required_attribute = newState?.category_settings?.attributes_mapping?.required_attribute

        if (init_required_attribute && required_attribute) {
            let inittempData: any = restructureAttributeSchemaToCompare(init_required_attribute);
            let tempData: any = restructureAttributeSchemaToCompare(required_attribute);
            tempData.map((att: any, index: number) => {
                let initAtt = inittempData?.find((a: any) => a?.amazon_attribute === att?.amazon_attribute)
                let flag = initAtt?.shopify_select === 'Search' && att?.shopify_select === 'Search' && initAtt?.shopify_attribute !== att?.shopify_attribute
                newState?.onSaveBarChange(flag, 'attributes_' + index)
            })
        }

        let init_optional_attribute = previousState?.category_settings?.attributes_mapping?.optional_attribute;
        let optional_attribute = newState?.category_settings?.attributes_mapping?.optional_attribute;

        if (init_optional_attribute && optional_attribute) {
            let initOptData: any = restructureAttributeSchemaToCompare(init_optional_attribute, true);
            let OptData: any = optional_attribute
            OptData?.map((att: any, index: number) => {
                let initAtt = initOptData?.find((a: any) => a?.amazon_attribute === att?.amazon_attribute)
                let flag = initAtt?.shopify_select === 'Search' && att?.shopify_select === 'Search' && initAtt?.shopify_attribute !== att?.shopify_attribute
                newState?.onSaveBarChange(flag, 'optional_attribute')
            })
        }

        // let init_edited_variant_attributes = restructureAttributeSchemaToCompare(prepareDataFormatingOptionalAttribute(previousState?.edited_variant_attributes))
        // let edited_variant_attributes = prepareDataFormatingOptionalAttribute(newState?.edited_variant_attributes)
        // if (edited_variant_attributes?.length > 0 && init_edited_variant_attributes?.length > 0) {
        //     newState?.onSaveBarChange(JSON.stringify(init_edited_variant_attributes) !== JSON.stringify(edited_variant_attributes), 'edited_variant_attributes')
        // }

    }
    else if (field === 'attributes') {
        let { index, value, field } = newState;
        if (newState?.contextualFreshProduct) {
            //----> this if case is only used to make false for all the attributes when user click the back btn for fresh product
            value?.map((event: any) => {
                previousState.onSaveBarChange(false, event);
            })
        } else {
            let tempData: any = restructureAttributeSchemaToCompare(initialComponentState?.['category_settings']?.['attributes_mapping']?.['required_attribute']);

            if (initialComponentState?.listing_type != previousState?.listing_type)
                previousState.onSaveBarChange(tempData?.[index]?.[field] != newState.value || initialComponentState?.listing_type != previousState?.listing_type, 'attributes_' + index)
            else
                previousState.onSaveBarChange(tempData?.[index]?.[field] != newState.value, 'attributes_' + index)
        }
    }
    else if (field === 'optional_attribute') {
        let currentState: any = restructureAttributeSchemaToCompare(action?.['payload']?.['optional_attribute'], true);
        // let currentState = prepareDataFormatingOptionalAttribute(tempData);
        let initialState = prepareDataFormatingInitOptionalAttribute(initialComponentState?.['category_settings']?.['attributes_mapping']?.['optional_attribute']);
        if (previousState?.listing_type !== previousState?.initialComponentState?.listing_type && previousState?.listing_type === "offer_listing") {
            previousState.onSaveBarChange(false, "optional_attribute");
        } else {
            previousState.onSaveBarChange(JSON.stringify(currentState) != JSON.stringify(initialState), "optional_attribute");
        }
    }
    else if (field === "variation_theme_fields") {
        let { index, value, field } = newState;
        previousState.onSaveBarChange(initialComponentState.variants[index]?.['variation_theme_fields']?.[field] != value, "variation_theme_fields_" + index + field);
    }
    else if (field === "variation_theme_attributes") {
        let compareInitial = (initialComponentState?.['variation_theme_attributes'] ?? [])?.map((obj: any) => {
            return {
                label: obj?.label,
                value: obj?.value,
                amazon_attribute: obj?.amazon_attribute,
                shopify_attribute: { value: obj?.shopify_attribute?.value },
            }
        })

        let compareNew = (newState?.['variation_theme_attributes'] ?? [])?.map((obj: any) => {
            return {
                label: obj?.label,
                value: obj?.value,
                amazon_attribute: obj?.amazon_attribute,
                shopify_attribute: { value: obj?.shopify_attribute?.value },
            }
        })

        previousState.onSaveBarChange(JSON.stringify(compareInitial) != JSON.stringify(compareNew), "variation_theme_attributes");
    }
    else if (field === 'barcode_exemption') {
        if (initialComponentState?.listing_type != previousState.listing_type && initialComponentState?.category_settings?.primary_category === "default" && initialComponentState?.hasOwnProperty('temp_profile_info')) {
            let calculateInitialBarcodeExceptional = initialComponentState?.temp_profile_info?.category_settings?.['barcode_exemption'];
            previousState.onSaveBarChange(calculateInitialBarcodeExceptional != newState[field], field);
        } else {
            previousState.onSaveBarChange(initialComponentState?.['data']?.[field] != newState[field], field);
        }
    }
    else if (field === 'add_variation_theme') {
        previousState.onSaveBarChange(initialComponentState?.['variation_theme']?.['variation_theme_attribute_name'] != newState?.['value']?.['value'], 'variation_theme_attribute_name')
    }
    else if (field === 'add_variants_to_grid') {
        let test = initialComponentState?.['variants'][0];
        if (test.hasOwnProperty('optional_attribute')) {
            previousState.onSaveBarChange(!Object.keys(test?.['optional_attribute']).includes(newState?.value?.value))
        }
    }
    else if (field === 'remove_attribute_from_variants') {
        if (action.payload?.['variants'] && initialComponentState?.['variants']?.[0])
            previousState.onSaveBarChange(JSON.stringify(action.payload?.['variants']?.[0]).trim().toLowerCase() != JSON.stringify(initialComponentState?.['variants']?.[0]).trim().toLowerCase())
    }
    else if (field === 'optional_attributes_variants_grid') {
        if (action.payload?.['variants'] && initialComponentState?.['variants'])
            previousState.onSaveBarChange(JSON.stringify(action.payload?.['variants']).trim().toLowerCase() != JSON.stringify(initialComponentState?.['variants']).trim().toLowerCase())
    }
    else if (field === 'variant_variation_theme_fields') {
        let change = 0;
        action?.payload?.variants?.map((variant: any) => {
            let initialVariant = initialComponentState?.variants?.find((vari: any) => vari?.source_product_id === variant?.source_product_id);
            initialVariant && Object.keys(variant?.variation_theme_fields ?? {}).map((key: string) => {
                change = variant?.variation_theme_fields?.[key] !== initialVariant?.variation_theme_fields?.[key] ? change + 1 : change;
            })
        })
        previousState.onSaveBarChange(change > 0, field);
    }
    else if (field === 'variation_theme') {
        previousState.onSaveBarChange(newState?.variation_theme?.value?.value != initialComponentState?.variation_theme?.variation_theme_attribute_name, field);
    }
    else if (field === 'flush_attributes') {
        let current_attribute: any = restructureAttributeSchemaToCompare(newState?.required_attribute);
        let previous_attribute: any = restructureAttributeSchemaToCompare(initialComponentState?.['category_settings']?.['attributes_mapping']?.['required_attribute']);
        current_attribute?.map((att: any, index: number) => {
            let prev_att = previous_attribute?.find((a: any) => a?.amazon_attribute === att?.amazon_attribute)
            let change = att?.shopify_select !== prev_att?.shopify_select ||
                (att?.shopify_select === 'custom' === prev_att?.shopify_select && att?.custom_text === prev_att?.custom_text) ||
                (att?.shopify_select === 'recommendation' === prev_att?.shopify_select && att?.recommendation === prev_att?.recommendation) ||
                (att?.shopify_select === 'Search' === prev_att?.shopify_select && att?.shopify_attribute === prev_att?.shopify_attribute)
            previousState.onSaveBarChange(change, 'attributes_' + index)
        })
    }
    else if (field === 'update_optional_attributes') {
        let currentState: any = restructureAttributeSchemaToCompare(action?.['payload']?.['optional_attribute'], true);
        // let currentState = prepareDataFormatingOptionalAttribute(tempData);
        let initialState = prepareDataFormatingInitOptionalAttribute(initialComponentState?.['category_settings']?.['attributes_mapping']?.['optional_attribute']);
        if (previousState?.listing_type !== previousState?.initialComponentState?.listing_type && previousState?.listing_type === "offer_listing") {
            previousState.onSaveBarChange(false, "optional_attribute");
        } else {
            previousState.onSaveBarChange(JSON.stringify(currentState) != JSON.stringify(initialState), "optional_attribute");
        }
    }
    else if (field == "price") {
        previousState.onSaveBarChange(!compareObjects(getSanitizedPrice(previousState?.initialComponentState?.data?.[field]), getSanitizedPrice(newState)), field);
    }
    else if (field == "quantity") {
        console.log(previousState?.initialComponentState?.data?.[field], newState,"dvfgb");
        
        previousState.onSaveBarChange(!compareObjects(getSanitizedQuantity(previousState?.initialComponentState?.data?.[field]), getSanitizedQuantity(newState)), field);
    }
    else if (field == "business_price_enabled") {
        previousState.onSaveBarChange(previousState?.initialComponentState?.data?.[field] != newState[field], field)
    }
    else if (field == "business_price") {
        previousState.onSaveBarChange(!compareObjects(previousState?.initialComponentState?.data?.[field], newState[field]), field)
    }
    else {
        if (newState?.[field] && initialComponentState?.['data']?.[field] || (newState?.[field] === '' || initialComponentState?.['data']?.[field] === '')) {
            previousState.onSaveBarChange(newState[field] != initialComponentState?.['data']?.[field], field);
        }
    }
    return {}
}